function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.84 46.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.84,15.45a15.42,15.42,0,1,0-27,10.17V41.47a4.82,4.82,0,0,0,4.82,4.82,4.76,4.76,0,0,0,3-1.06l3.14-2.5a1,1,0,0,1,1.2,0l3.13,2.5A4.81,4.81,0,0,0,27,41.47V25.62A15.32,15.32,0,0,0,30.84,15.45ZM15.42,3.89A11.57,11.57,0,1,1,3.85,15.45,11.56,11.56,0,0,1,15.42,3.89Zm7.16,38.44a1,1,0,0,1-1-.11l-3.13-2.51a4.81,4.81,0,0,0-6,0L9.28,42.22a1,1,0,0,1-1.36-.15.93.93,0,0,1-.21-.6V28.79a15.3,15.3,0,0,0,15.42,0V41.47A.93.93,0,0,1,22.58,42.33Z",
    style: {
      fill: "currentColor"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster);
export default __webpack_public_path__ + "static/media/master.865a0703.svg";
export { ForwardRef as ReactComponent };